import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Subheading from "../../../components/common/Subheading";
import { authenticateUserPassword, logoutUser, updatePassword } from "../../../services/auth/authorisation";
import FormField from "./FormField";
import FormSection from "./FormSection";
import PasswordRules from "./PasswordRules";

/**
 * ChangePassword component
 *
 * A reusable component for password change functionality
 *
 * @param {Object} props - Component props
 * @param {function} props.showAlert - Function to show alerts
 * @returns {JSX.Element} Change password form component
 */
function ChangePassword({ showAlert }) {
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [otpValue, setOtpValue] = useState("");

  const onOldPassword = (e) => setOldPassword(e.target.value);
  const onNewPassword = (e) => setNewPassword(e.target.value);
  const onOtp = (e) => setOtpValue(e.target.value);

  const onSuccess = async () => {
    setTimeout(async () => {
      console.log(await logoutUser());
      navigate("/login");
    }, 1000);
  };

  const onSubmit = async () => {
    if (oldPassword.length === 0 || newPassword.length === 0) {
      showAlert("error", "Invalid Inputs!");
      return;
    }

    // At least one upper case English letter, (?=.*?[A-Z])
    // At least one lower case English letter, (?=.*?[a-z])
    // At least one digit, (?=.*?[0-9])
    // At least one special character, (?=.*?[#?!@$%^&*-])
    // Minimum eight in length .{8,} (with the anchors)
    const re = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$");
    if (!re.test(newPassword)) {
      showAlert("error", "New password does not meet requirements");
      return;
    }

    const authenticatedRes = await authenticateUserPassword(oldPassword, otpValue);
    if (authenticatedRes.msg !== "success") {
      showAlert("error", authenticatedRes.msg);
      return;
    }

    const updatePasswordRes = await updatePassword(newPassword);
    if (!updatePasswordRes.updated) {
      showAlert("error", updatePasswordRes.msg);
      return;
    }

    showAlert("success", "Successfully Changed Password!");
    onSuccess();
  };

  return (
    <Grid container direction="column" px={{ xs: 2, md: "10%" }} width={"100%"} spacing={3}>
      <Subheading text="Change Password" sx={{ mb: 3, fontSize: "1.5rem" }} />

      <FormSection title="Current Authentication">
        <FormField
          fieldLabel="Current Password"
          type="password"
          value={oldPassword}
          onChange={onOldPassword}
          label="Current Password"
        />
        <FormField fieldLabel="OTP" value={otpValue} onChange={onOtp} label="OTP" />
      </FormSection>

      <FormSection title="New Password">
        <FormField
          fieldLabel="New Password"
          label="New Password"
          type="password"
          value={newPassword}
          onChange={onNewPassword}
          helperText={<PasswordRules />}
        />
      </FormSection>

      <Box display={"flex"} justifyContent={"center"} mt={2}>
        <Button variant="contained" size="large" sx={{ py: 1.2, px: 4, borderRadius: 2 }} onClick={onSubmit}>
          Change Password
        </Button>
      </Box>
    </Grid>
  );
}

export default ChangePassword;
